module.exports = __webpack_public_path__ + "static/media/icon_arrowkeys.4f9e38df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/infopanel/icon_arrowkeys.svg
// module id = 437
// module chunks = 0